import { render } from "./FilterBar.vue?vue&type=template&id=2beda596&bindings={\"sortingOptions\":\"props\",\"dismissMore\":\"options\",\"doSignup\":\"options\",\"numberWithCommas\":\"options\"}"
import script from "./FilterBar.vue?vue&type=script&lang=js"
export * from "./FilterBar.vue?vue&type=script&lang=js"

import "./FilterBar.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script